import './Marquee.scss'

const ITEMS = [
  'Ceară naturală de soia',
  'Flori uscate naturale',
  'Fabricat artizanal',
  'Uleiuri esențiale premium',
  'Cadouri perfecte',
  'Fără aditivi chimici',
  'Produs în România',
]

export default function Marquee() {
  const doubled = [...ITEMS, ...ITEMS]

  return (
    <div className="marquee-wrap">
      <div className="marquee-track">
        {doubled.map((text, i) => (
          <span className="marquee-item" key={i}>
            {text} <span className="marquee-dot">✦</span>
          </span>
        ))}
      </div>
    </div>
  )
}
